'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _mkAppLoader = require('mk-app-loader');

var _componentFactory = require('./componentFactory');

var _componentFactory2 = _interopRequireDefault(_componentFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toast, notification, modal, errorBox, apps;

function config(option) {
	var components = option.components;

	toast = option.toast;
	notification = option.notification;
	modal = option.modal;
	errorBox = option.errorBox;
	apps = option.apps;

	(0, _mkAppLoader.config)(option);

	_componentFactory2.default.registerComponent('AppLoader', _mkAppLoader.AppLoader);

	if (components && components.length > 0) {
		components.forEach(function (c) {
			if (c.appName) _componentFactory2.default.registerAppComponent(c.appName, c.name, c.component);else _componentFactory2.default.registerComponent(c.name, c.component);
		});
	}

	if (apps) {
		(0, _keys2.default)(apps).forEach(function (k) {
			var a = apps[k];
			if (a.components && a.components.length > 0) {
				a.components.forEach(function (c) {
					_componentFactory2.default.registerAppComponent(a.name, c.name, c.component);
				});
			}
		});
	}
}

config.getToast = function () {
	return toast;
};
config.getNotification = function () {
	return notification;
};
config.getModal = function () {
	return modal;
};
config.getApps = function () {
	return apps;
};

exports.default = config;
module.exports = exports['default'];